import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';

interface MembersManagementHeaderProps {
  readonly title: string;
  readonly description: string;
  readonly count: number;
  readonly actions?: ReactNode;
}

export function MembersManagementHeader({
  title,
  description,
  count,
  actions,
}: MembersManagementHeaderProps) {
  return (
    <header className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
          <Badge
            variant="outline"
            className="min-w-8 justify-center rounded-full bg-card px-2.5 py-1 text-sm font-medium text-muted-foreground"
          >
            {count}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
    </header>
  );
}
